// eslint-disable-next-line @tseslint/no-shadow
import { ChangeDetectionStrategy, Component, computed, inject, model, ModelSignal, Signal, AfterViewInit } from '@angular/core';
import { SideMenuComponent } from '@shared/components/side-menu/side-menu.component';
import { TranslationPipeModule } from '@ogs-gmbh/ngx-translate';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LanguageSelectionService } from '@shared/components/language-selection/services/language-selection/language-selection.service';
import { OverviewSettingsMenuService } from '../../services/overview-settings-menu.service';
import { SideMenuTabGroupComponent } from "@shared/components/side-menu/components/side-menu-tab-group/side-menu-tab-group.component";
import { SideMenuTabComponent } from "@shared/components/side-menu/components/side-menu-tab/side-menu-tab.component";
import { SideMenuTabLabel } from '@shared/components/side-menu/components/side-menu-tab/directives/side-menu-tab-label.directive';
import { IconModule } from "@ogs-gmbh/ngx-m3-components";
import { OverviewSettingsMenuFilterComponent } from "./components/overview-settings-menu-filter/overview-settings-menu-filter.component";
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faGear, faSliders } from '@fortawesome/pro-light-svg-icons';
import { OverviewSettingsMenuFieldsComponent } from "./components/overview-settings-menu-fields/overview-settings-menu-fields.component";
import { TableConfig } from '@shared/components/table-implementation/types/table-config';
import { toSignal } from '@angular/core/rxjs-interop';
import { findFilterByType } from '@shared/components/table-implementation/types/filter/table-filter.type';
import { TableConfigService } from '@core/services/table/table-config.service';

@Component({
  selector: 'app-overview-settings-menu',
  standalone: true,
  imports: [ SideMenuComponent,
    TranslationPipeModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    SideMenuTabGroupComponent,
    SideMenuTabComponent,
    SideMenuTabLabel,
    IconModule,
    OverviewSettingsMenuFilterComponent,
    OverviewSettingsMenuFieldsComponent ],
  templateUrl: './overview-settings-menu.component.html',
  styleUrl: './overview-settings-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverviewSettingsMenuComponent implements AfterViewInit {
  private _faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  private _tableConfigService: TableConfigService = inject(TableConfigService);

  private _overviewSettingsMenuService: OverviewSettingsMenuService = inject(OverviewSettingsMenuService);

  private _selectedTableConfig: Signal<TableConfig | undefined> = toSignal(this._tableConfigService.selectedConfig$);

  // eslint-disable-next-line @unicorn/consistent-function-scoping
  protected hasFilter: Signal<boolean> = computed(() =>
    Boolean(this._selectedTableConfig()?.filterConfig?.filterGroups)
    // eslint-disable-next-line @tseslint/no-non-null-assertion
    && this._selectedTableConfig()!.filterConfig!.filterGroups.length > 0);

  protected isMenuExpanded: ModelSignal<boolean> = model(false);

  protected languageSelectionService: LanguageSelectionService = inject(LanguageSelectionService);

  protected findFilterByType: typeof findFilterByType = findFilterByType;

  constructor () {
    this._faIconLibrary.addIcons(faGear, faSliders);
  }

  public ngAfterViewInit (): void {
    this._overviewSettingsMenuService.onMenuOpen$.subscribe(() => {
      this.isMenuExpanded.set(true);
    });
  }
}
